<template>
  <div class="field" v-show="visible">
    <div class="field-selection-container number-selection-container">
      <input v-model="field.value" type="number"/>
      <div class="error" v-if="field.invalid && !field.value">This field is required</div>
    </div>
  </div>

</template>

<script>
    import Field from './Field'
    export default {
        name: 'NumberField',
        extends: Field,
        props: [],
        methods: {
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// node_modules/survey-fields/src/Question/Fields/NumberField.vue